module.exports = __webpack_public_path__ + "static/media/eventage824.fe3d45d9.png";